<template>
    <DDropdown
        id="tenant_dropdown"
        v-c-tooltip="__('messages.header.tenant_selection.title')"
        dropdown-id="tenant_dropdown_menu"
        add-menu-classes="pt-0"
        class="override-overlap"
        :toggler-text="getTenantName(tenant)"
        icon="domain"
        color="secondary"
        :caret="true"
    >
        <DDropdownItem
            v-for="tenantElement in tenants"
            :id="`tenant_item_${tenantElement.id}`"
            :key="tenantElement.id"
            @click="select(tenantElement.id)"
        >
            {{ tenantElement.company_name }}
        </DDropdownItem>
    </DDropdown>
</template>

<script>
export default {
    name: 'DTenantDropdown',
    props: {
        tenant: {
            type: String,
            required: false,
            default: null
        },
        tenants: {
            type: Array,
            required: false,
            default: () => { return [] }
        }
    },
    methods: {
        select (tenantId) {
            this.$inertia.get(this.$route('tenant.set', { tenant: tenantId, switchTenant: true }))
        },
        getTenantName (tenantId) {
            if (tenantId === '' || tenantId === null) {
                return
            }

            return this.tenants.find(x => x.id === tenantId).company_name
        }
    }
}
</script>

<style lang="scss" scoped>
.tenant-link {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: 0 10px;
    border: 1px solid rgba(0,0,0,0.14);
    padding: 3px 10px;
    border-radius: 5px;
    margin-left: 10px;

    & div:nth-child(1) {
        grid-row: 1 / span 2;
        color: rgba(0,0,0,0.4);
    }
    & div:nth-child(2) {
        font-weight: bold;
        font-size: 10px;
        margin-bottom: -5px;
    }
    & div:nth-child(3) {
        grid-row: 2;
        grid-column: 2;
    }

    &:hover {
        background: rgba(0,0,0,0.07);
    }
}
.dropdown {
    &.override-overlap {
        z-index: 1030;
    }
}
</style>

<style>
#tenant_dropdown_menu {
    max-height: 80vh;
    overflow-y: auto;
}
</style>
